module.exports = __webpack_public_path__ + "img/1006_pc.45ebc063.gif";